import { render, staticRenderFns } from "./TypebotSubmissions.vue?vue&type=template&id=0bd26281&scoped=true"
import script from "./TypebotSubmissions.vue?vue&type=script&lang=js"
export * from "./TypebotSubmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd26281",
  null
  
)

export default component.exports